import { api } from '../../../../../lib/api';

/**
 * 스페이스에 저장된 역할별 권한 목록
 * @returns {Promise<Array<{ memberRoleCd: string, permissions: object }>>}
 */
export async function fetchAllianceSpaceRolePermissionList(spaceUid) {
  if (!spaceUid) return [];
  const res = await api.get(`/api/alli/spaces/${encodeURIComponent(spaceUid)}/role-permissions`);
  return Array.isArray(res) ? res : [];
}

/**
 * 단일 역할 권한 (없으면 permissions: {})
 * @returns {Promise<{ memberRoleCd: string, permissions: object }>}
 */
export async function fetchAllianceSpaceRolePermission(spaceUid, memberRoleCd) {
  if (!spaceUid || !memberRoleCd) {
    return { memberRoleCd: memberRoleCd || '', permissions: {} };
  }
  return api.get(
    `/api/alli/spaces/${encodeURIComponent(spaceUid)}/role-permissions/${encodeURIComponent(memberRoleCd)}`,
  );
}

/**
 * 역할 권한 전체 저장 (consortium, calendar, boards, dynamic)
 */
export async function saveAllianceSpaceRolePermission(spaceUid, memberRoleCd, permissions) {
  if (!spaceUid || !memberRoleCd) {
    throw new Error('spaceUid and memberRoleCd are required');
  }
  return api.put(
    `/api/alli/spaces/${encodeURIComponent(spaceUid)}/role-permissions/${encodeURIComponent(memberRoleCd)}`,
    permissions,
  );
}

function unwrapAlliancePermPayload(raw) {
  if (raw == null || typeof raw !== 'object') {
    return { memberRoleCd: '', permissions: {} };
  }
  const inner =
    raw.data != null && typeof raw.data === 'object' && !Array.isArray(raw.data) ? raw.data : raw;
  const memberRoleCd =
    inner.memberRoleCd ??
    inner.member_role_cd ??
    '';
  const permissions =
    inner.permissions != null && typeof inner.permissions === 'object' ? inner.permissions : {};
  return { memberRoleCd: String(memberRoleCd).trim(), permissions };
}

/**
 * 현재 로그인 사용자의 역할 코드 + 기본값·DB 병합 권한
 * @returns {Promise<{ memberRoleCd: string, permissions: object }>}
 */
export async function fetchMyAllianceSpaceRolePermissions(spaceUid) {
  if (!spaceUid) {
    return { memberRoleCd: '', permissions: {} };
  }
  const raw = await api.get(`/api/alli/spaces/${encodeURIComponent(spaceUid)}/role-permissions/me`);
  return unwrapAlliancePermPayload(raw);
}
